import type {Contact} from 'src/types/contacts';
import type {EditorDispatch} from 'src/reducers/thread-list-editor';

import * as React from 'react';

import logger from 'src/utils/logger';

import Editor from 'src/components/contacts/editor';
import {createContact} from 'src/thunks/contacts';

import {useDispatch} from 'react-redux';
import css from './contact-adder.css';


type Props = {
  dispatch: EditorDispatch;
  contact: Contact;
  errors: Record<any, any>;
};

export default function Adder({
  dispatch,
  contact,
  errors,
}: Props): React.ReactElement<React.ComponentProps<'div'>> {
  const [isPosted, setPosted] = React.useState(false);
  const dispatcher = useDispatch();

  const handleSubmit = React.useCallback(
    (event: React.SyntheticEvent<HTMLFormElement>) => {
      event.preventDefault();

      if (errors) {
        setPosted(true);
      } else {
        const formDataDetails = {
          email: '',
          firstName: '',
          lastName: '',
          phoneNumbers: [],
        } as const;
        const formData = new FormData(event.currentTarget);
        for (const [key, value] of formData.entries()) {
          if (key === 'phone') {
            const valueOfPhone: string = value.toString();
            // @ts-expect-error - TS2540 - Cannot assign to 'phoneNumbers' because it is a read-only property.
            formDataDetails['phoneNumbers'] = [
              {value: valueOfPhone, primary: true},
            ];
          } else {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly email: ""; readonly firstName: ""; readonly lastName: ""; readonly phoneNumbers: readonly []; }'.
            formDataDetails[key] = value;
          }
        }
        // @ts-expect-error - TS2345 - Argument of type '{ readonly email: ""; readonly firstName: ""; readonly lastName: ""; readonly phoneNumbers: readonly []; }' is not assignable to parameter of type 'ContactNew'.
        dispatcher(createContact(formDataDetails));
        dispatch({type: 'create'});
        setPosted(false);
      }
    },
    [errors, dispatch],
  );

  const handleChange = React.useCallback(
    // @ts-expect-error - TS7006 - Parameter 'propName' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
    (propName, value) => {
      logger.log('change', propName);
      dispatch({
        type: 'edit',
        payload: {[propName]: value},
      });
    },
    [dispatch],
  );

  const handleCancel = React.useCallback(
    () => dispatch({type: 'clear'}),
    [dispatch],
  );

  return (
    <div className={css.box}>
      <Editor
        contact={contact}
        // @ts-expect-error - TS2322 - Type 'Record<any, any> | null' is not assignable to type 'Record<any, any>'.
        errors={isPosted ? errors : null}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
}
